/**
 * mediasoup-client browser bundle
 * 
 * This file re-exports mediasoup-client for use in the browser.
 * It's bundled separately to avoid loading the full library on every page.
 */

// Import from npm package
import { Device } from 'mediasoup-client';

// Export for ES module usage
export { Device };

// Also expose on window for non-module scripts
if (typeof window !== 'undefined') {
    window.mediasoupClient = { Device };
}
